export default __webpack_public_path__ + "static/media/hero-animation-03.728df3d0.svg";